import React from 'react';
import BottomNav from './BottomNav';
import DesktopSidebar from './DesktopSidebar';

interface LayoutProps {
  children: React.ReactNode;
}

const Layout: React.FC<LayoutProps> = ({ children }) => {
  return (
    <div className='min-h-screen flex flex-col md:flex-row bg-base'>
      {/* Desktop sidebar — md+ (icon-only at md, full at lg); bottom nav takes over below md.
          Row direction must switch at the same md breakpoint the sidebar appears, else the
          full-height sidebar stacks above the content at tablet widths. */}
      <DesktopSidebar />

      {/* Content column */}
      <div className='flex-1 flex flex-col min-w-0'>
        <main className='flex-1'>{children}</main>
        <BottomNav />
      </div>
    </div>
  );
};

export default Layout;
